export const environment = {
    local       : false,
    production  : false,
    hmr         : false,

    appName: `ORCA [[ DEVELOP ]]`,

    wsPort:     80,
    wsHost:     'https://apidev.orcaapp.com.br',
    wsAppId:     "7F79E681D29F73C8",
    apiHost:     'https://apidev.orcaapp.com.br',
    baseUrl:     'https://paineldev.orcaapp.com.br',
    apiUrl:     'https://apidev.orcaapp.com.br/api',
    storageUrl:  'https://apidev.orcaapp.com.br/storage',
    
    pusherKey:   'e3a3289a044ff1ffaa31',
    pusherCluster: 'mt1',
    broadcaster: 'pusher',
};